import { useState } from 'react';
import * as Sentry from '@sentry/react';
import Cookies from 'js-cookie';
import { ETracker } from 'common/tracker';
import { setIsAdmin, setUserInfo } from '@/store/user';
import service from '@/service';
import { useAppDispatch } from './useAppDispatch';

export const useAfterLogin = () => {
  const dispatch = useAppDispatch();
  const [isLogin, setIsLogin] = useState(false);

  const checkUser = async () => {
    const user = await service.userSetting.getCurrentUserInfoTiangong();

    if (user && user.uniqueId) {
      Sentry.setUser({ username: user?.name });
      ETracker.setConfig({
        uid: user.uniqueId,
        username: user.name,
        dim1: 'pc',
      });
      setIsLogin(true);

      return user;
    } else {
      setIsLogin(false);
    }
  };
  const afterRbacLogin = async () => {
    const user = await checkUser();

    if (user) {
      dispatch(setUserInfo(user));
      dispatch(setIsAdmin(user?.isAdmin));

      const token = Cookies.get('RBAC_TOKEN');
      if (token) {
        await service.fosServer.fosLogin(token, user.name);
      }
      return user;
    } else {
      return null;
    }
  };

  return { afterRbacLogin };
};
